import React from 'react';
import { tierForLevel } from '../../utils/levels';
import './game.css';

export default function DiscoveryOverlay({ placement, xpResult, fragmentsCount = 0, onClose }) {
  if (!placement) return null;
  const leveledUp = !!xpResult?.leveledUp;
  const tier = leveledUp ? tierForLevel(xpResult.nextLevel) : null;

  return (
    <div className="discovery-overlay" onClick={onClose}>
      <div className="discovery-card" onClick={(e) => e.stopPropagation()}>
        <span className="discovery-eyebrow">Nuevo descubrimiento</span>
        <div className="discovery-figure">
          <span className="discovery-ring" />
          {placement.thumbnailUrl ? (
            <img src={placement.thumbnailUrl} alt={placement.title} />
          ) : (
            <i className="bi bi-gem" style={{ fontSize: '2.4rem', color: '#6de8ff' }} />
          )}
        </div>
        <h3 className="discovery-title">Has descubierto: <b>{placement.title}</b></h3>
        <p className="discovery-sub">
          Se agregó a tu Museo Virtual. Seguí explorando para completar tu colección.
        </p>

        {fragmentsCount > 0 && (
          <div className="discovery-fragments-hint">
            <i className="bi bi-collection-fill" />
            Contiene {fragmentsCount} fragmento{fragmentsCount === 1 ? '' : 's'} cultural{fragmentsCount === 1 ? '' : 'es'} para explorar en RA
          </div>
        )}

        {xpResult?.gained ? (
          <span className="discovery-xp-chip">+{xpResult.gained} XP</span>
        ) : null}

        {leveledUp && (
          <div className="discovery-levelup">
            <span className="discovery-levelup-eyebrow">¡Subiste de nivel!</span>
            <strong>Nivel {xpResult.nextLevel} · {tier?.name}</strong>
          </div>
        )}

        <button className="discovery-close-btn" onClick={onClose}>Ver la obra</button>
      </div>
    </div>
  );
}
